import { styled } from "@mui/material/styles";
import { Box, Button, ButtonProps, Checkbox, Typography } from "@mui/material";
import Colors from "src/general/constants/colors";
import BreakPoints from "src/general/constants/breakPoints";

export const MaterialEventContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px",
	padding: "0px",
	margin: "0px",
	width: "100%",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "16px",
		},
}));

export const MaterialLinks = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "12px",
	borderRadius: "16px",
	gap: "16px",
	backgroundColor: Colors.WHITE,
	boxShadow: "0px 4px 16px 0px #7474741F",
	maxWidth: "100%",
	flexWrap: "nowrap",

	[`@media  (min-width: ${BreakPoints.MOBILE_767}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "8px",
			padding: "8px",
		},

	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
		{
			flexWrap: "wrap",
			gap: "8px",
		},
}));

export const TicTac = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	borderRadius: "16px",
	padding: "8px 16px",
	cursor: "pointer",
	gap: "8px",
	backgroundColor: Colors.GREY_F6,
	width: "100%",
	whiteSpace: "nowrap",
	boxSizing: "border-box",

	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
		{
			width: "fit-content",
			whiteSpace: "wrap",
		},
}));

export const MoreTicTac = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: "4px",
	cursor: "pointer",
}));
export const ButtonUpDown = styled("div")({
	display: "flex",
	alignItems: "center",
	width: "14px",
	height: "12px",
});
export const StyledBox = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "left",
	padding: "16px",
	cursor: "pointer",
	width: "fit-content",
	height: "fit-content",
	gap: "16px",
}));

export const VideoAndInfoContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	flexWrap: "wrap",
	gap: "24px",
	alignItems: "stretch",

	[`@media  (min-width: ${BreakPoints.LARGE_1439}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			gap: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			flexDirection: "column",
		},
}));

export const VideoModule = styled("section")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	borderRadius: "16px",
	padding: "20px",
	gap: "16px",
	width: "calc(50% - 12px)",
	flexGrow: 1,
	boxSizing: "border-box",

	backgroundColor: Colors.WHITE,
	boxShadow: "0px 4px 16px 0px #7474741F",
	[`@media  (min-width: ${BreakPoints.LARGE_1439}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			width: "calc(50% - 8px)",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			padding: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			width: "100%",
		},
}));

export const TitleContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "4px",

	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
		{
			flexDirection: "column-reverse",
			alignItems: "start",
			gap: "16px",
		},
}));

export const InfoTitle = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "start",
	gap: "4px",
}));

export const Baydges = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "4px",
}));

export const Baydge = styled("div")(({ theme, color }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	padding: "8px 16px",
	borderRadius: "32px",
	backgroundColor: color,

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "6px 12px",
		},
}));

export const NameModule = styled("div")(({ theme }) => ({
	display: "flex",
	flexGrow: 1,
	textAlign: "left",
	alignItems: "flex-start",
}));

////////////////////////////////////PROGRESS BAR
export const ProgressBar = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
}));

export const TitleProgressBarContainer = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	width: "100%",
}));

export const TitleRowContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "baseline",
	gap: "4px",
}));

//////////////////////////////////////////LeftRight button
export const LeftRightButtons = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	gap: "16px",

	[`@media  (min-width: ${BreakPoints.MOBILE_767}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			width: "80%",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
		{
			flexDirection: "column",
		},
}));

export const LinkButton = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	boxSizing: "border-box",
	padding: "8px 22px",
	alignItems: "start",
	borderRadius: "32px",
	cursor: "pointer",
	gap: "12px",
	color: Colors.BLUE_015,
	border: `1px solid ${Colors.BLUE_015}`,
	whiteSpace: "nowrap",

	transition: "transform 0.2s ease, box-shadow 0.2s ease",

	"&:hover": {
		transform: "translate(-3px -3px)",
		boxShadow: `-2px 4px 8px ${Colors.BLUE_LIGHT}`,
	},
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
	color: Colors.BLACK_OLD,
}));

export const Title = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "8px",
}));
